import { render, staticRenderFns } from "./KingstonCity.vue?vue&type=template&id=c811f9e0&scoped=true&"
import script from "./KingstonCity.vue?vue&type=script&lang=js&"
export * from "./KingstonCity.vue?vue&type=script&lang=js&"
import style0 from "./KingstonCity.vue?vue&type=style&index=0&id=c811f9e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c811f9e0",
  null
  
)

export default component.exports